const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'EDIT_PROFILE':
      return { ...state, [action.key]: action.value };
    case 'LOAD_PROFILE':
      return { ...state, ...action.user };
    case 'CLEAR':
      return { ...initialState };
    default:
      return state;
  }
};
